<div *ngIf="show" 
     [class]="'alert-container ' + type"
     [@fadeInOut]>
  <div class="alert-content">
    <mat-icon>{{ type === 'success' ? 'check_circle' : 'error' }}</mat-icon>
    <span>{{ message }}</span>
  </div>
</div> 